
<!--yyyy-mm  默认显示当前月份-->
<template>
  <div class="DatePicker">
    <div v-if="!isRowPicker" class="dateWrapper">
      <span @click="cutMonth">
        <van-icon name="arrow-left"/>
      </span>
      <span @click="selectDate">
        {{showDate}}
        <i class="triangle_border_down"></i>
      </span>
      <span @click="addMonth">
        <van-icon name="arrow"/>
      </span>
    </div>
    <span class="rowSpan" v-else @click="selectDate">
      <span class="rowSpan">{{showDate ? (showDate.split("-")[0] + '年' + showDate.split("-")[1] + (isBill ? '期' :'月')) : ''}}</span>
      <i v-if="isBill" class="corner"/>
      <van-icon v-else name="arrow"/>
    </span>
    <van-popup position="bottom" v-model="show">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :title="title ? title : ''"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { DatetimePicker, Popup, Icon, Toast } from "vant";

Vue.use(DatetimePicker)
  .use(Popup)
  .use(Icon)
  .use(Toast);

export default {
  name: "datePicker",
  props: ["currentMonth", "isRowPicker","title", "isBill", "minDate", "maxDate", "minDateMsg", "maxDateMsg"],
  components: {},
  data() {
    return {
      show: false,
      currentDate: new Date(),
      showDate: moment().format("YYYY-MM")
    };
  },
  mounted() {
    if (this.currentMonth) {
      this.showDate = this.currentMonth;
      this.currentDate = new Date(this.showDate);
    } else {
      this.showDate = moment().format("YYYY-MM");
    }
  },
  watch: {
    currentMonth:{
      handler() {
        this.showDate = this.currentMonth;
        this.currentDate = new Date(this.currentMonth);
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        if(this.isBill){
          return `${value}期`;
        }else{
          return `${value}月`;
        }
        
      }
      return value;
    },
    onConfirm(e) {
      let dateVal = moment(e).format("YYYY-MM");
      this.showDate = dateVal;
      this.$emit("dateChange", dateVal);
      this.show = false;
    },
    onCancel() {
      this.currentDate = new Date(this.showDate.replace(/-/g,'/'));
      this.showDate = moment(this.showDate.replace(/' '/g,'')).format("YYYY-MM");
      this.show = false;
    },
    selectDate() {
      this.show = true;
    },
    cutMonth() {
      if (this.minDate) { // 日期范围控制
        const minDate = moment(this.minDate);
        const newShowDate = moment(this.showDate).subtract(1, "months");
        if (minDate.isAfter(newShowDate)) {
          if (this.minDateMsg) {
            Toast(this.minDateMsg);
          }
          return;
        }
      }
      let date = moment(this.showDate.replace(/' '/g,'')).subtract(1,"months").format("YYYY-MM");
      this.showDate = date;
      this.currentDate = new Date(date);
      this.$emit("dateChange", this.showDate);
    },
    addMonth() {
      if (this.maxDate) {
        const maxDate = moment(this.maxDate);
        const newShowDate = moment(this.showDate).add(1, "months");
        if (maxDate.isBefore(newShowDate)) {
          if (this.maxDateMsg) {
            Toast(this.maxDateMsg);
          }
          return;
        }
      }
      let date = moment(this.showDate.replace(/' '/g,'')).add(1,"months").format("YYYY-MM");
      this.showDate = date;
      this.currentDate = new Date(date);
      this.$emit("dateChange", this.showDate);
    }
  }
};
</script>
<style lang="stylus" scoped>

.DatePicker {
  position relative
  .corner{
    width: 0px;
    height: 0px;
    border: 4px solid #b4bec7;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    position: absolute;
    right: -0.12rem;
    top: 0.1rem;
  }
  .dateWrapper {
    text-align: center;
    font-size: 0.16rem;
    padding: 0.14rem 0;
    color: #1fadf6;
  }

  span {
    padding: 0 0.12rem;
  }

  .triangle_border_down {
    width: 0;
    height: 0;
    border-width: 5px 5px 0;
    border-style: solid;
    border-color: #1fadf6 transparent transparent;
    position: relative;
    top: 0.1rem;
    left: 0.08rem;
  }
  .rowSpan{
    padding 0
  }
  .van-icon-arrow{
    margin-left 0.04rem
    position relative
    top 0.02rem
  }
}
</style>